/**
 * SkipLinkButton.tsx — слово владельца 21.10.2026 (задание stylepack/skip-link):
 * ссылка «Пропустить» под кнопкой «Далее». Рисуется веткой `button_next`
 * общего рендера (PublicBlockRenderer.tsx — там только вызов).
 *
 * Настоящая `<button type="button">` (доступна с клавиатуры и читалке), без
 * рамки и заливки. Нажатие зовёт `onSkip` — переход визарда «без ответа»
 * (skipAdvance.ts); визард без такого перехода (пейволл) отдаёт сюда переход
 * главной кнопки. В редакторе ссылка видна, но экран не переводит — как и
 * кнопка-ссылка в превью (шрам WEB-846). Нет подписи — ничего не рисуется.
 *
 * `SkipOnlyLink` — блок «Далее» с `skipOnly` (skipOnlyActive): вместо кнопки
 * только ссылка, в той же обёртке по центру и с тем же отступом снизу, что у
 * кнопки, — там, где стоял бы блок.
 */
import React from 'react';
import { useEditorPreview } from './EditorPreviewContext';
import { skipLinkLabel, skipLinkStyle, type SkipLinkFields } from './skipLink';

export function SkipLinkButton({
  block,
  onSkip,
}: {
  block: SkipLinkFields;
  onSkip?: () => void;
}): React.ReactElement | null {
  const { isEditorPreview } = useEditorPreview();
  const label = skipLinkLabel(block);
  if (label === null) return null;
  const live = isEditorPreview ? undefined : onSkip;
  return (
    <button
      type="button"
      data-testid="quiz-skip-link"
      // Как у главной кнопки: нажатие не отбирает фокус у поля ввода, иначе
      // focusout включил бы авто-переход раньше клика (keepFieldFocusOnPress).
      onMouseDown={live ? (e) => e.preventDefault() : undefined}
      onClick={live}
      style={skipLinkStyle(block)}
    >
      {label}
    </button>
  );
}

export function SkipOnlyLink({
  block,
  onSkip,
}: {
  block: SkipLinkFields;
  onSkip?: () => void;
}): React.ReactElement {
  return (
    <div
      data-testid="quiz-skip-only"
      style={{ textAlign: 'center', marginBottom: 16 }}
    >
      <SkipLinkButton block={block} onSkip={onSkip} />
    </div>
  );
}
